import React from "react";
import Wheel from './Wheel';

export default function Roleta({rodando,setRodando}){
    return (
        <Wheel rodando={rodando} setRodando={setRodando} />
    );
}
